import Vue from 'vue';
import Tab from '../general/tab';
import axios from 'axios';
import * as Utils from '../../utils';
import * as FormHelpers from '../../helpers/formhelpers';
import 'jquery-validation';

export default Vue.component('detailtab', {
    extends: Tab,
    data: function(){
        return {
            servicePointId: null,
            axe: axios.create({
                baseURL: '/mywecycle/servicepoint'
            }),
            form: null,
            validator: null
        }
    },
    methods:{
        /**
         *Initializes the detail tab form
         *
         * @param {*} tabElem
         */
        initializeForm(tabElem){
            this.form = tabElem.find('.js-servicepoint-details');
            this.validator = this.form.validate({
                errorClass: 'invalid-feedback animated fadeIn',
                errorElement: 'div',
                errorPlacement: (error, el) => {
                    $(el).addClass('is-invalid');
                    $(el).parents('.form-group').append(error);
                },
                highlight: el => {
                    $(el).parents('.form-group').find('.is-invalid').removeClass('is-invalid').addClass('is-invalid');
                },
                success: el => {
                    $(el).parents('.form-group').find('.is-invalid').removeClass('is-invalid');
                    $(el).remove();
                },
                groups: {
                    collectionusertypes: 'operations--servicepoint__collectsfromconsumers operations--servicepoint__collectsfrombusiness'
                },
                rules: {
                    'operations--servicepoint__name': {
                        required: true
                    },
                    'operations--servicepoint__startdate': {
                        required: true
                    },
                    'operations--servicepoint__contacts': {
                        required: true
                    },
                    'operations--servicepoint__pickupaddress': {
                        required: true
                    },
                    'operations--servicepoint__visitingaddress': {
                        required: true
                    },
                    'operations--servicepoint__collectsfromconsumers': {
                        require_from_group: {
                            param: [1, '.operations--servicepoint__collectionusertypes'],
                            depends: function (element) {
                                if ($('input[name="operations--servicepoint__usersearchenginedetails"]:checked').length > 0) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        }
                    },
                    'operations--servicepoint__collectsfrombusiness': {
                        require_from_group: {
                            param: [1, '.operations--servicepoint__collectionusertypes'],
                            depends: function (element) {
                                if ($('input[name="operations--servicepoint__usersearchenginedetails"]:checked').length > 0) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        }
                    },
                    'operations--servicepoint__serviceaccepttypes': {
                        required: {
                            depends: function (element) {
                                if ($('input[name="operations--servicepoint__usersearchenginedetails"]:checked').length > 0) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        }
                    }
                },
                messages: {
                    'operations--servicepoint__collectsfromconsumers': {
                        // look for other data attribute, because razor doesn't like "_" in data attributes
                        require_from_group: function (params, element) {
                            return $(element).data('msg-require-from-group');
                        }
                    },
                    'operations--servicepoint__collectsfrombusiness': {
                        // look for other data attribute, because razor doesn't like "_" in data attributes
                        require_from_group: function (params, element) {
                            return $(element).data('msg-require-from-group');
                        }
                    }
                }
            });
        },
        /** Saves the detail form */
        saveTab(){
            if (this.validator.form()){
                let addressId = parseInt($('#operations--servicepoint__pickupaddress').val());
                let servicePointRoleId = $('[data-role-id]', this.form).data('role-id') || $('[data-role-id]', this.form).val();
                
                // Remove disabled properties to include fields in formData
                const disabledFields = $(':input:disabled', this.form).add('option:disabled').removeAttr('disabled');

                // Get formData
                let formData = FormHelpers.getFormData(this.form);

                // Re-disable previously enabled fields
                disabledFields.attr('disabled', 'disabled');

                this.axe.get('/checkifservicepointisduplicated', { params:{ 
                    addressId: addressId,
                    spRoleId: servicePointRoleId,
                    servicePointId: this.servicePointId
                }})
                .then((response) => {
                    if(response.data && response.data.Duplicated && this.servicePointId === null){
                        One.helpers('notify', { type: 'danger', icon: 'fa fa-exclamation-triangle mr-1', message: response.data.Message });
                    } else {
                        this.axe.post('/servicepointdetail', formData)
                        .then((response) => {
                            if(response.data.ServicePointId){
                                this.$parent.onServicePointCreate(response.data.ServicePointId);
                                return true;
                            }
                            return false;
                        })
                        .then((submitedWithSuccess) => {
                            if(submitedWithSuccess){ this.$emit('submit', true); }
                        })
                        .catch((error) => {
                            console.log('Error saving detail tab : ' + error);
                            this.$emit('submiterror');
                        });        
                    }
                })
                .catch((error) => {
                    console.log('Error saving detail tab : ' + error);
                    this.$emit('submiterror');
                });
            } else {
                this.validator.focusInvalid();
            }
        },
        /** Initializes the tab content elements */
        initializeContent(tabElem){
            this.initializeForm(tabElem);
            One.helpers(['core-bootstrap-popover', 'core-bootstrap-tooltip', 'core-toggle-class', 'select2', 'datepicker', 'masked-inputs', 'maxlength', 'table-tools-sections']);

            // Capitalize first letter of name on keyup
            tabElem.find('#operations--servicepoint__name').keyup(function () {
                Utils.capitalizeTextBox($(this));
            });

            const businessCheckbox = document.getElementById('operations--servicepoint__collectsfrombusiness')
            if (businessCheckbox) {
                businessCheckbox.addEventListener('change', (event) => {
                    const informationField = document.getElementById('additionalInfo')
                    if (!informationField) {
                        return;
                    }
                    if (event.target.checked) {
                        informationField.classList.remove('d-none')
                    } else {
                        informationField.classList.add('d-none')
                    }
                })
            }
            
            MyStichtingOpen.Contacts.initContactPersonModal();
            MyStichtingOpen.Addresses.initAddressModal();
            MyStichtingOpen.ServicePoints.searchEngine();
        },
        /** Loads the detail tab content */
        loadContent(){
            this.servicePointId = this.$parent.servicePointId;
            this.axe.get('/servicepointdetailtab?', { params: { servicePointId: this.servicePointId }})
            .then((response) => { return this.renderTabContent(response.data); })
            .then((tabElem) => { this.initializeContent(tabElem) })
            .catch((error) => { console.log('Error retrieving tab content : ' + error); });
        }
    },
    created() {
        this.loadContent();

        this.$root.$on("destroyDetailTab", () => {
            this.$destroy();
        })
    },
    beforeDestroy() {
        const businessCheckbox = document.getElementById('operations--servicepoint__collectsfrombusiness')
        if (businessCheckbox) {
            businessCheckbox.removeEventListener('change')
        }
    }
});